// extracted by mini-css-extract-plugin
export var checkbox = "checkboxBlock-module--checkbox--3PsAa";
export var checkboxBlock = "checkboxBlock-module--checkboxBlock--u-iOF";
export var hintIconClose = "checkboxBlock-module--hintIconClose--F2qc4";
export var hintIconQuestion = "checkboxBlock-module--hintIconQuestion--LMPs2";
export var hintText = "checkboxBlock-module--hintText--RyhWX";
export var invitefriend = "checkboxBlock-module--invitefriend--s0FSb";
export var plait = "checkboxBlock-module--plait--yUf6A";
export var round = "checkboxBlock-module--round--C8CR7";
export var slider = "checkboxBlock-module--slider--jXJu+";
export var text = "checkboxBlock-module--text--bdVQ9";
export var tooltip = "checkboxBlock-module--tooltip--VgL1S";
export var tooltipIcon = "checkboxBlock-module--tooltipIcon--4mjSx";